import React from "react";


const AiInsightsTextSize = ({ isDisable, reduceSize, increaseSize }) => (
  <div style={{ display: "flex" }}>
    <div
      className={
        isDisable ? "font-button increase disable" : "font-button increase"
      }
      onClick={!isDisable ? () => {
        increaseSize();
      } : null}
    >
      A
    </div>
    <div
      className={
        isDisable ? "font-button decrease disable" : "font-button decrease"
      }
      onClick={!isDisable ? () => {
        reduceSize();
      } : null}
    >
      A
    </div>
  </div>
);


export default AiInsightsTextSize;
